// smart search buttons
document.addEventListener("DOMContentLoaded", () => {
    const searchFormNav = document.querySelector(".search-window form");
    const searchInputNav = searchFormNav.querySelector(".search-window form input");
    document.querySelectorAll(".js-search-suggestion").forEach(s => {
        s.addEventListener("click", () => {
            searchInputNav.value = s.innerHTML
            //.replace(/\?/g, "%3F");
            searchFormNav.submit();
        });
    })
})



document.addEventListener("DOMContentLoaded", () => {
    const searchFormNav = document.querySelector(".search-window form");
    const searchSuggestions = searchFormNav.querySelector(".search-suggestions");
    const searchSpinner = document.querySelector(".loader-container");
    const formSection = document.querySelector(".search-form");
    searchFormNav.addEventListener("submit", (e) => {
        e.preventDefault();
        console.info("Smart Search query submitted...")
        //searchSuggestions.style.display = "none";
        formSection.style.display = "none";
        searchSpinner.style.display = "block";
        searchFormNav.submit();
    })
})